import * as React from "react";

import "./template-creation-route-load.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Invoke}         from "@Common/react/invoke";
import {Load2}          from "@Common/react/load2";
import {UseState}       from "@Common/react/use-state";
import {CcApis3}        from "@Common/tools/cc-integration/cc_apis/cc-apis-3";

import {TemplateUploadModal} from "../template-upload-modal/template-upload-modal"
import {LoadingSpinner}      from "../template-upload-modal/components/loading-spinner";

// TODO: Move this into ../template-upload-modal/views.
// This content is only used in that modal. When moving, refactor to use CST2 and make the render the final function of
// the chain service.

export const TemplateCreationRouteLoad = ({
    match,
    newTemplate  = true,
    acknowledgements,
    filePath,
    onError
}:{
    match            : any,
    newTemplate     ?: boolean,
    acknowledgements : string,
    filePath         : string,
    onError          : (message:string) => void,
}) => cs(
    consumeContext("apis"),
    consumeContext("catSubStyle"),
    consumeContext("company"),
    consumeContext("session"),
    consumeContext("systemConstants"),
    consumeContext("routerHistory"),
    ["renderEmptyLayout", (_, next) => next((message) => (
        <div className="template-creation-route-load-6rs">
            <LoadingSpinner text="Preparing Template"/>
        </div>
    ))],
    ({company, renderEmptyLayout}, next) => !company ? (
        renderEmptyLayout("Loading company data")
    ) : (
        next()
    ),
    ({systemConstants, renderEmptyLayout}, next) => systemConstants.loading ? (
        renderEmptyLayout("Loading system constants")
    ) : (
        next()
    ),
    ["template", ({apis}, next) => Load2({
        fetch: () => match.params.template_id ? apis.next.userCreated.getTemplate(match.params.template_id) : {},
        next,
    })],
    ({template, renderEmptyLayout}, next) => template.loading ? (
        renderEmptyLayout("Loading template")
    ) : (
        next()
    ),
    ["ccHostResponse", ({systemConstants, template}, next) => Load2({
        fetch: async () => {
            const ccApi = CcApis3({host: systemConstants.value.DS_SERVER_URL});
            return await ccApi.getHost({
                templateId: match.params.source_id ?? template.value?.sourceTemplateId,
                stateId: template.value?.idState
            });
        },
        next
    })],
    ({ccHostResponse, renderEmptyLayout}, next) => ccHostResponse.loading ? (
        renderEmptyLayout("Loading dependencies")
    ) : !ccHostResponse.value || ccHostResponse.value.ccHost === "" ? ( /* check ccHost for empty string only - if null, then want to continue to next to allow the error modal to display */
        Invoke({ fn: () => onError("Could not load dependencies. Please try again later.") })
    ) : (
        next()
    ),
    ["mockData", ({apis}, next) => Load2({
        fetch: () => apis.next.mockData.getMockData(),
        next,
    })],

    ({mockData, renderEmptyLayout}, next) => mockData.loading ? (
        renderEmptyLayout("Loading dependencies")
    ) : !mockData.value || mockData.value.ccHost === "" ? (
        Invoke({ fn: () => onError("Could not load dependencies. Please try again later.") })
    ) : (
        next()
    ),

    ["dataProperties", ({template}, next) => UseState({
        initValue: template.value?.ccConfig ? JSON.parse(template.value.ccConfig)?.["ccJson"]?.["frames"] : {},
        next
    })],
    ["data1", ({template}, next) => UseState({
        initValue: template.value?.ccConfig ? JSON.parse(template.value.ccConfig)?.["xdJson"]?.["templateConfigurations"] : "",
        next,
    })],
    ["data2", ({template}, next) => UseState({
        initValue: template.value?.ccConfig ? JSON.parse(template.value.ccConfig)?.["xdJson"]?.["templateBindingData"] : "",
        next,
    })],
    ["preview", (_, next) => UseState({
        initValue: false,
        next,
    })],
    ["updating", (_, next) => UseState({
        defaultValue: {
            downloadPercent: 0,
        },
        next,
    })],
    ["editingStateId", (_, next) => UseState({next})],
    ["previewState", (_, next) => UseState({next})],
    ["previewHighResUrls", (_, next) => UseState({next})],
    ["templateUploadModal", ({}, next) => TemplateUploadModal({activeTab: null, next})],
    ["toDbJsonPrep", (_, next) => UseState({ initValue: {}, next })],
    ({dataProperties, data1, data2, editingStateId, mockData, preview, previewState, previewHighResUrls, template, toDbJsonPrep, updating, routerHistory, ccHostResponse}) => {
        let state = {
            dataProperties,
            data1,
            data2,
            editingStateId,
            mockData,
            preview,
            previewState,
            previewHighResUrls,
            template,
            toDbJsonPrep,
            updating,
            ccHostResponse,
            acknowledgements,
            filePath
        };

        localStorage.setItem('templateCreationState', JSON.stringify(state));
        if (newTemplate) {
            routerHistory.replace(`/manage-templates/create-template/${match.params.source_id}`);
        } else {
            routerHistory.replace(`/manage-templates/update-template/${match.params.template_id}`);
        }
    },
);